export function setWindowConfig(obj) {
  window.__env = obj;
}

export function addToConfig(obj) {
  window.__env = {
    ...window.__env,
    ...obj
  };
}

export function getConfig(key) {
  return window.__env[key] || null;
}

export function getConfigs(keys) {
  let result = []
  for (let key of keys) {
    result.push(window.__env[key] || null)
  }
  return result
}